// Typed accessor for the web bundle's build metadata. The values are injected
// at compile time by `define` in vite.config.ts (env-first: VITE_GIT_SHA /
// VITE_BUILD_TIME, with a git/`'dev'` fallback). Components read from here
// rather than touching the raw `__WEB_BUILD_*__` globals.
export const webBuildInfo = {
  sha: __WEB_BUILD_SHA__,
  buildTime: __WEB_BUILD_TIME__,
} as const;
